import palette from '../palette';

export default {
  styleOverrides: {
    root: {
      borderRadius: 4
    },
    filledInfo: {
      backgroundColor: palette.alerts.info.background
    },
    standardInfo: {},
    filledWarning: {
      backgroundColor: palette.alerts.warning.background
    },
    standardWarning: {},
    filledError: {
      backgroundColor: palette.alerts.error.background
    },
    standardError: {}
  }
};
